import React from 'react';
import { Route, IndexRoute } from 'react-router';

import TashiDesktop from './app/components/TashiDesktop';
import Notifications from './app/components/Notifications';

import AttributeManagement from './app/components/AttributeManagement';
import EditLogs from './app/components/EditLogs';
import Export from './app/components/Export';
import FloatingTasks from './app/components/FloatingTasks';
import LogEntryAdder from './app/components/LogEntryAdder';
import LogOverview from './app/components/LogOverview';
import PendingApprovals from './app/components/PendingApprovals';
import PMO from './app/components/PMO';
import StaffOverview from './app/components/StaffOverview';
import TimesheetOverview from './app/components/TimesheetOverview';
import UsersOverview from './app/components/UsersOverview';
import WeekSheetApproval from './app/components/WeekSheetApproval';

export default (
    <Route path="/" component={TashiDesktop}>
        <IndexRoute component={Notifications}/>
        <Route path="attributes" component={AttributeManagement}/>
        <Route path="approve" component={WeekSheetApproval}/>
        <Route path="editLogs" component={EditLogs}/>
        <Route path="export" component={Export}/>
        <Route path="floatingTasks" component={FloatingTasks}/>
        <Route path="logEntryAdder" component={LogEntryAdder}/>
        <Route path="logOverview" component={LogOverview}/>
        <Route path="pendingApprovals" component={PendingApprovals}/>
        <Route path="pm" component={PMO}/>
        <Route path="pmo" component={PMO}/>
        <Route path="staffOverview" component={StaffOverview}/>
        <Route path="timesheetOverview" component={TimesheetOverview}/>
        <Route path="usersOverview" component={UsersOverview}/>
        <Route path="notifications" component={Notifications}/>
    </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/